module.exports = __webpack_public_path__ + "static/media/cq_calendario_plus.183492d2.svg";